import { MainContentArea, ContentHeader } from "melco-ui";
import { useTranslation } from "react-i18next";
import { LogsList } from "../../components/logs/LogsList";

export const Logs: React.FC = () => {
  const { t } = useTranslation();
  //const breadcrumb = useBreadcrumb("logs");

  return (
    <>
      <MainContentArea header={<ContentHeader title={t("main_menu.logs")} />}>
        <LogsList />
      </MainContentArea>
    </>
  );
};
